import React, { useState, useEffect, useContext } from 'react';
import TitleBar from '../components/TitleBar.jsx';
import '../styles/prompt_library.css';
import { Tooltip, } from 'react-tooltip';
import { urlValue } from '../lib'
import { projectContext, loadingContext, unfolder, openAlert, useTranslate } from '../lib'
import axios from 'axios';
import { Alerts } from '../components/common/Alerts'
import PromptTemplateModal from '../components/PromptTemplateModal.jsx';

const PromptLibrary = () => {
    const [loading, setLoading] = useContext(loadingContext);
    const [promptData, setPromptData] = useState({
        role: '',
        task: '',
        context: '',
        options: {}
    });
    const [alert, setAlert] = useState({ title: '', visible: false })
    const { t } = useTranslate();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const userId = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    // Función para obtener los datos del prompt
    const getPromptDefault = async () => {
        try {
            const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
            const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;

            const response = await axios({
                method: 'get',
                url: `${urlValue}/studio/prompt/library/default`,
                headers: {
                    user: id,
                    'access-token': token,
                }
            });

            if (response.data) {
                setPromptData({
                    ...response.data,
                    context: response.data.context || '',
                    example: response.data.example || ''
                });
                // También actualizamos los valores de los textareas
                //document.getElementById('role').value = response.data.role || '';
                //document.getElementById('task').value = response.data.task || '';
                document.getElementById('context').value = response.data.context || '';
                //document.getElementById('rules').value = response.data.rules || '';
                //document.getElementById('forbidden_actions').value = response.data.forbidden_actions || '';
                //document.getElementById('default_fallback').value = response.data.default_fallback || '';
                document.getElementById('example').value = response.data.example || '';
                //document.getElementById('other').value = response.data.other || '';
                const options = JSON.parse(response.data.options || '{}');
                document.getElementById('friendly').value = options?.mood?.friendly || '';
                document.getElementById('angry').value = options?.mood?.angry || '';
                document.getElementById('sad').value = options?.mood?.sad || '';
                document.getElementById('unfriendly').value = options?.mood?.unfriendly || '';
                document.getElementById('excited').value = options?.mood?.excited || '';
                document.getElementById('calm').value = options?.mood?.calm || '';
                document.getElementById('short').value = options?.responseLength?.short || '';
                document.getElementById('medium').value = options?.responseLength?.medium || '';
                document.getElementById('long').value = options?.responseLength?.long || '';
                document.getElementById('talkative_yes').value = options?.talkativeMood?.yes || '';
                document.getElementById('talkative_no').value = options?.talkativeMood?.no || '';

            }
        } catch (error) {
            console.error('Error al obtener el prompt default:', error);
        }
    };

    // Cargar datos cuando el componente se monta
    useEffect(() => {
        getPromptDefault();
    }, []);

    const savePromptDefault = async (e) => {
        //e.preventDefault();

        //setLoading(true);

        //const rolContent = document.getElementById('role').value;
        //const taskContent = document.getElementById('task').value; 
        const contextContent = document.getElementById('context').value;
        //const rulesContent = document.getElementById('rules').value;
        //const forbiddenActionsContent = document.getElementById('forbidden_actions').value;
        //const defaultFallbackContent = document.getElementById('default_fallback').value;
        const exampleContent = document.getElementById('example').value;
        //const otherContent = document.getElementById('other').value;
        const friendlyContent = document.getElementById('friendly').value;
        const angryContent = document.getElementById('angry').value;
        const sadContent = document.getElementById('sad').value;
        const unfriendlyContent = document.getElementById('unfriendly').value;
        const excitedContent = document.getElementById('excited').value;
        const calmContent = document.getElementById('calm').value;
        const shortContent = document.getElementById('short').value;
        const mediumContent = document.getElementById('medium').value;
        const longContent = document.getElementById('long').value;
        const talkativeYesContent = document.getElementById('talkative_yes').value;
        const talkativeNoContent = document.getElementById('talkative_no').value;

        const data = {
            //role: rolContent,
            //task: taskContent,
            context: contextContent,
            //rules: rulesContent,
            //forbidden_actions: forbiddenActionsContent,
            //default_fallback: defaultFallbackContent,
            example: exampleContent,
            //other: otherContent,
            options: JSON.stringify({
                mood: {
                    friendly: friendlyContent,
                    angry: angryContent,
                    sad: sadContent,
                    unfriendly: unfriendlyContent,
                    excited: excitedContent,
                    calm: calmContent
                },
                responseLength: {
                    short: shortContent,
                    medium: mediumContent,
                    long: longContent
                },
                talkativeMood: {
                    yes: talkativeYesContent,
                    no: talkativeNoContent
                }
            })
        }
        console.log('data', data)
        const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        const csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

        axios({
            method: 'post',
            url: `${urlValue}/studio/prompt/library/save`,
            headers: {
                user: id,
                'access-token': token,
                'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
            data: data,
        }).then(function (res) {
            setLoading(false);
            setPromptData(data);
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.promptTemplateSave'), visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }).catch(error => {
            console.log('Error to try update bot sentiment: ', error);
        })
    }

    const handleSelectTemplate = (templateContent, templateExample) => {
        //onst currentContext = document.getElementById('context').value;

        setPromptData(prev => ({
            ...prev,
            context: templateContent || '',
            example: templateExample || ''
        }));

        const contextElement = document.getElementById('context');
        const exampleElement = document.getElementById('example');

        if (contextElement) contextElement.value = templateContent || '';
        if (exampleElement) exampleElement.value = templateExample || '';

        setIsModalOpen(false);
    };

    return <div className='general-container'>
        <TitleBar />
        <div className='primary-container d-flex flex-row flex-wrap justify-content-between mt-3'>
            <h1>{t('menu.genai.promptLibrary')}</h1>
            <div className="box-tool">
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <h2>{t('menu.genai.defaultPromptData')}:</h2>
                    <div style={{ marginRight: 12, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div style={{ padding: '0 20px 0 0' }}>
                            <button onClick={() => setIsModalOpen(true)}
                                className='button-setup camp-btn' type="button" style={{ borderRadius: 5, backgroundColor: '#5c5c5c', marginRight: '5px' }}
                            >
                                {t('common.templates')}
                            </button>
                        </div>


                        <div className='tooltip-div' >
                            <img id="campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                            <button onClick={savePromptDefault}
                                className='button-setup camp-btn' type="button" style={{ borderRadius: 5, backgroundColor: '#0038A8' }}
                            >
                                {t('common.save')}
                            </button>
                            <Tooltip events={['click']} anchorId="campaing-tp" st={undefined}
                                content={t('menu.genai.promptTemplateTooltip')} place="top" />
                        </div>

                    </div>

                </div>
                <form id="prompt-default-form" className='d-flex flex-wrap' >
                    {/* <div className='items-little'>
                        <div className='input-container'>
                            <label htmlFor="role">{t('menu.genai.role')}:</label>
                            <textarea name="role" id="role" rows="4" />
                        </div>
                        <div className='input-container'>
                            <label htmlFor="task">{t('menu.genai.task')}:</label>
                            <textarea name="task" id="task" rows="4" />
                        </div>
                    </div> */}
                    <div className='item-context'>
                        <div className='input-container' style={{ width: '100%' }}>
                            <label htmlFor="context">{t('menu.genai.context')}:</label>
                            <textarea
                                name="context"
                                id="context"
                                rows="11"
                                value={promptData.context}
                                onChange={(e) => setPromptData({ ...promptData, context: e.target.value })}
                            />
                        </div>
                    </div>
                    <div id='secondary_container' class="w-100 d-flex flex-row flex-wrap">
                        {/* <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="rules">{t('menu.genai.rules')}:</label>
                                <textarea name="rules" id="rules" rows="6" />
                            </div>
                        </div>
                        <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="forbidden_actions">{t('menu.genai.forbiddenActions')}</label>
                                <textarea name="forbidden_actions" id="forbidden_actions" rows="6" />
                            </div>
                        </div>
                        <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="default_fallback">{t('menu.genai.defaultFallback')}:</label>
                                <textarea name="default_fallback" id="default_fallback" rows="6" />
                            </div>
                        </div> */}
                        <div className='items-little'>
                            <div className='input-container' style={{ width: '100%' }}>
                                <label htmlFor="example">{t('menu.genai.example')}:</label>
                                <textarea name="example" id="example" rows="6" />
                            </div>
                        </div>
                        {/* <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="other">{t('common.other')}:</label>
                                <textarea name="other" id="other" rows="6" />
                            </div>
                        </div> */}
                        <div className='items-little'>
                            <div className='input-container' style={{ width: '100%', gap: 1 }}>
                                <label><b>Mood:</b></label>
                                <label class="mt-1">Friendly:</label>
                                <textarea id="friendly" placeholder="Friendly" rows="3" />
                                <label>Angry:</label>
                                <textarea id="angry" placeholder="Angry" rows="3" />
                                <label>Sad:</label>
                                <textarea id="sad" placeholder="Sad" rows="3" />
                                <label>Unfriendly:</label>
                                <textarea id="unfriendly" placeholder="Unfriendly" rows="3" />
                                <label>Excited:</label>
                                <textarea id="excited" placeholder="Excited" rows="3" />
                                <label>Calm:</label>
                                <textarea id="calm" placeholder="Calm" rows="3" />
                            </div>
                        </div>


                        <div className='items-little'>
                            <div className='input-container' style={{ width: '100%', gap: 1 }}>
                                <label><b>Response Length:</b></label>
                                <label class="mt-1">Short:</label>
                                <textarea id="short" placeholder="Short" rows="3" />
                                <label>Medium:</label>
                                <textarea id="medium" placeholder="Medium" rows="3" />
                                <label>Long:</label>
                                <textarea id="long" placeholder="Long" rows="3" />
                            </div>
                        </div>


                        <div className='items-little'>
                            <div className='input-container' style={{ width: '100%', gap: 1 }}>
                                <label><b>Talkative Mode:</b></label>
                                <label class="mt-1">Yes:</label>
                                <textarea id="talkative_yes" placeholder="Yes" rows="3" />
                                <label>No:</label>
                                <textarea id="talkative_no" placeholder="No" rows="3" />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row-reverse', flexWrap: 'wrap', width: '100%' }}>
                        <div className='tooltip-div' style={{ marginRight: 12 }}>
                            <img id="campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                            <button onClick={savePromptDefault}
                                className='button-setup camp-btn' type="button" style={{ borderRadius: 5, backgroundColor: '#0038A8' }}
                            >
                                {t('common.save')}
                            </button>
                            <Tooltip events={['click']} anchorId="campaing-tp" st={undefined}
                                content={t('menu.genai.promptTemplateTooltip')} place="top" />
                        </div>
                    </div>

                </form>
            </div>


        </div>

        <PromptTemplateModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSelect={handleSelectTemplate}
            userId={userId}
        />

        {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
    </div>
}

export default PromptLibrary;